import styled from "styled-components";

export const IconContainer = styled.div`
  background-color: #11A557;
  padding: 8px;
  border-radius: 50%;
`;